import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { UtilService, DialogService, NotificationService, TranslationService, DatagridService } from '../../../shared/index';
import { Router, ActivatedRoute } from '@angular/router';
import { CardConnectService } from '../shared/card-connect.service';
import { FundingResponse } from '../shared/funding-response.model';
import { NavigationService } from '../../../shared/navigation/navigation.service';

@Component({
  selector: 'wl-card-connect-input',
  templateUrl: 'card-connect-input.component.html',
  styleUrls: ['card-connect-input.component.css'],
  providers: [CardConnectService],
  standalone: false
})
export class CardConnectInputComponent implements OnInit {
  public _utilService: UtilService;
  public _notifyService: NotificationService;
  public _translationService: TranslationService;
  public _route: ActivatedRoute;
  public _cardConnectService: CardConnectService;
  public _dialogService: DialogService;

  public token: string;
  public tokenError: string;

  public constructor(
    utilService: UtilService,
    notifyService: NotificationService,
    translationService: TranslationService,
    route: ActivatedRoute,
    cardConnectService: CardConnectService,
    dialogService: DialogService
  ) {
    this._utilService = utilService;
    this._notifyService = notifyService;
    this._translationService = translationService;
    this._route = route;
    this._cardConnectService = cardConnectService;
    this._dialogService = dialogService;

    this.token = '';
    this.tokenError = '';
  }

  public ngOnInit() {
    window.addEventListener(
      'message',
      event => {
        let token: any = JSON.parse(event.data);
        if (token.validationError === undefined) {
          this.tokenError = '';
        } else {
          this.tokenError = token.validationError;
        }

        this.token = token.message;
      },
      false
    );
  }

  public isValid = (): boolean => {
    if (this._utilService.isNotNullEmptyOrWhitespace(this.tokenError)) {
      return false;
    } else {
      return true;
    }
  };

  public clearForm = (): void => {
    //tokenizer doesn't expose a way to clear out contents
    //but reloading the iframe does the trick
    let tokenizerFrame: any = document.getElementById('tokenFrame');
    let tokenizerSource = tokenizerFrame.src;
    tokenizerFrame.src = '';
    tokenizerFrame.src = tokenizerSource;
  };
}
